<template>
  <el-pagination class='el-pagination'
                 style='margin-top: 10px;'
                 @size-change="sizeChange"
                 @current-change="pageChange"
                 layout="total, sizes, prev, pager, next, jumper"
                 :page-sizes="pageSizes"
                 :page-size="pageData.rows"
                 :current-page="pageData.page"
                 :total="pageData.total">
  </el-pagination>
</template>

<script>
export default {
  props: {
    pageData: {},
    pageSizes: {
      default: function() {
        return [10, 50, 100, 500, 1000];
      },
    }
  },
  methods: {
    sizeChange(val) {
      this.pageData.rows = val;
      this.$emit('sizeChange', val);
    },
    pageChange(val) {
      this.pageData.page = val;
      this.$emit('pageChange', val);
    }
  }
}
</script>

<style scoped>
.el-pagination {
  position: absolute;
  bottom: 0;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/cx/cxPagination.vue